import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    SubTitle,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const IMG_PATH = `${ASSETS_PATH}/img/order-help/arrowhead`;

const arrowheadData: Array<TableData> = [
    {
        kind: '矢尻の個数',
        about4: 4,
        about6: 6,
        about8: 8,
        about10: 10,
        about12: 12,
        about20: 20,
    },
    {
        kind: '予備の矢尻の個数',
        about4: 2,
        about6: 3,
        about8: 4,
        about10: 5,
        about12: 6,
        about20: 10,
    },
    {
        kind: '矢尻の合計数',
        about4: 6,
        about6: 9,
        about8: 12,
        about10: 15,
        about12: 18,
        about20: 30,
    },
];

type TableData = {
    kind: string;
    about4: number;
    about6: number;
    about8: number;
    about10: number;
    about12: number;
    about20: number;
};

const TableRow: FC<{ row: TableData }> = ({ row }) => (
    <tr className="table-row">
        <td className="text-align-center strong">{row.kind}</td>
        <td className="text-align-center">{row.about4}</td>
        <td className="text-align-center">{row.about6}</td>
        <td className="text-align-center">{row.about8}</td>
        <td className="text-align-center">{row.about10}</td>
        <td className="text-align-center">{row.about12}</td>
        <td className="text-align-center">{row.about20}</td>
    </tr>
);

const Table: FC<{ data: Array<TableData> }> = ({ data }) => (
    <table className="order-parts-help-table">
        <thead className="header">
            <tr>
                <th className="text-align-center">
                    <strong>ご注文の矢の本数</strong>
                </th>
                <th className="text-align-center">
                    <strong>4本セット</strong>
                </th>
                <th className="text-align-center">
                    <strong>6本セット</strong>
                </th>
                <th className="text-align-center">
                    <strong>8本セット</strong>
                </th>
                <th className="text-align-center">
                    <strong>10本セット</strong>
                </th>
                <th className="text-align-center">
                    <strong>12本セット</strong>
                </th>
                <th className="text-align-center">
                    <strong>20本セット</strong>
                </th>
            </tr>
        </thead>
        <tbody>
            {data.map((row, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <TableRow key={index} row={row} />
            ))}
        </tbody>
    </table>
);

export const ArrowheadInner: FC<{ className?: string }> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            矢尻の選び方
        </Title>
        <Image src={`${IMG_PATH}/arrowhead.png`} />
        <Paragraph>
            矢尻は矢の根、板付（いたつけ）とも呼ばれます。
            矢尻の重さを変えることで、矢の重心バランスを変えることができます。
            ステンレス製・真鍮製の物は錆びにくいです。
        </Paragraph>

        <SubTitle>予備の矢尻について</SubTitle>
        <Paragraph>
            ご注文いただく矢の本数に応じて、下記のとおり予備の矢尻をお付けいたします。
        </Paragraph>
        <div className="overflow-x-scroll">
            <Table data={arrowheadData} />
        </div>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpArrowhead: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <ArrowheadInner />
            </div>
        </div>
    </Panel>
);
